export enum ArchCompleteStatus {
  UPPER_COMPLETED = "UPPER_COMPLETED",
  LOWER_COMPLETED = "LOWER_COMPLETED",
  BOTH_ARCHES_COMPLETED = "BOTH_ARCHES_COMPLETED",
}
